import React from 'react';

import { usePermissions } from '../../hooks/usePermissions';

export interface PermissionGateProps {
  permission?: string;
  permissions?: string[];
  role?: string;
  roles?: string[];
  requireAll?: boolean;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

export const PermissionGate: React.FC<PermissionGateProps> = ({
  permission,
  permissions,
  role,
  roles,
  requireAll = false,
  fallback = null,
  children,
}) => {
  const { hasPermission, hasRole } = usePermissions();

  // Check single permission
  const hasSinglePermission = permission ? hasPermission(permission) : true;

  // Check multiple permissions
  const hasMultiplePermissions = permissions
    ? requireAll
      ? permissions.every(p => hasPermission(p))
      : permissions.some(p => hasPermission(p))
    : true;

  // Check single role
  const hasSingleRole = role ? hasRole(role) : true;

  // Check multiple roles
  const hasMultipleRoles = roles ? roles.some(r => hasRole(r)) : true;

  // Determine if user has access
  const hasAccess =
    hasSinglePermission &&
    hasMultiplePermissions &&
    hasSingleRole &&
    hasMultipleRoles;

  if (!hasAccess) {
    return fallback ? <>{fallback}</> : null;
  }

  return <>{children}</>;
};

export default PermissionGate;